import React, { Component } from 'react'
import { Icon } from 'semantic-ui-react'
import cn from 'classnames'

export default class RemoveButton extends Component {
  handleRemove = () => {
    const { id, onClick } = this.props
    onClick(id)
  }

  render() {
    const { rounded } = this.props
    return (
      <div
        className={cn('remove-button-container', { rounded })}
        onClick={this.handleRemove}
      >
        <Icon name='trash' link />
      </div>
    )
  }
}
